export default "__VITE_ASSET__DnWguTjX__"